module.exports = __webpack_public_path__ + "static/media/title-border-line.4cfdd2cd.svg";